import React, { Suspense, useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { 
  activeformEditEntiteState, 
  activeformNewEntiteState, 
  addEntiteFileState, 
  apiCollectionState, 
  apiPciState, 
  boolModifState, 
  collectionsCurState, 
  collectionsState, 
  currentPageEntityAtom, 
  idDataEntityState, 
  idLayerEditState, 
  loadingState, 
  localDataState, 
  markerFormEditState, 
  modeleLayerCurState, 
  openCollectionShareStates, 
  openCollectionStates, 
  reloadEntiteState, 
  searchQueryEntityAtom, 
  selectedNameCollectionState, 
  sortConfigEntityAtom, 
  toastState, 
  typeCollectionState, 
  typeformEditEntiteState, 
  userDataState 
} from '../../atoms/CollectionState';
import genStyles from '../generale.module.css';
import ResultForm from '../resultat/resultatForm';
import menuStyles from '../resultat/searchActionsMenu.module.css';
import EntityNewForm from './entityNewForm';
import MarkerForm from './entityEditForm/markerForm';
import CollectionService from '../../service/CollectionService';
import DrawService from '../../service/DrawService';
import ShowService from '../../service/showService';
import MarkerTextForm from './entityEditForm/markerTextForm';
import PolylineForm from './entityEditForm/polylineForm';
import PolygonForm from './entityEditForm/polygonForm';
import CircleForm from './entityEditForm/circleForm';
import FullScreenModal from '../modalForm/fullScreenModal';
import DeleteCollectionForm from '../collection/deleteCollectionForm';
import ExcelService from '../../service/excelService';
import SharedCollectionForm from '../collection/sharedCollectionFrom';
import TooltipForm from '../tooltipForm';
import ConfirmSaveForm from './confirmSaveForm';
import SetStyleForm from './setStyleForm';
import { toKML } from '@placemarkio/tokml';

const AddEntityFileForm = React.lazy(() => import("./addEntityFileForm"));

export default function EntityList({ 
  collectionName, 
  initGeocoder,  
  fileTypesLinks, 
  mymap, 
  onParcellesFetched, 
  modeleCollection, 
  featureGroup }) {
  const [entites, setEntites] = useState([]);
  const [allOpen, setAllOpen] = useState(false); 
  const [openStates, setOpenStates] = useState({});
  const [activeNew, setActiveNew] = useRecoilState(activeformNewEntiteState);
  const [activeEdit, setActiveEdit] = useRecoilState(activeformEditEntiteState);
  const [typeEdit,setTypeEdit] = useRecoilState(typeformEditEntiteState);
  
  const LocalData = useRecoilValue(localDataState);
  const api_collection = useRecoilValue(apiCollectionState);
  const api_pci = useRecoilValue(apiPciState);  
  const user_data = useRecoilValue(userDataState);  
  const setSelected = useSetRecoilState(selectedNameCollectionState);
  const iddCollectionSelected = useRecoilValue(idDataEntityState);
  const modeleLayer = useRecoilValue(modeleLayerCurState);

  const [openStatescoll,setOpenStatesColl] = useRecoilState(openCollectionStates);
  const openShareStates = useRecoilValue(openCollectionShareStates); 
  const [sortConfigEntity, setSortConfigEntity] = useRecoilState(sortConfigEntityAtom);
  const [searchQueryEntity, setSearchQueryEntity] = useRecoilState(searchQueryEntityAtom);
  const [currentPageEntity, setCurrentPageEntity] = useRecoilState(currentPageEntityAtom);
  const setForm = useSetRecoilState(markerFormEditState);
  const [layerEdit,setLayerEdit] = useRecoilState(idLayerEditState);
  const resetLayerEdit = useResetRecoilState(idLayerEditState);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showConfirmModalDeleteAll, setShowConfirmModalDeleteAll] = useState(false);
  const [objetCur, setObjetCur] = useState({});
  const typeCollection = useRecoilValue(typeCollectionState);      
  const [showSharedModal, setShowSharedModal] = useState(false); 
  const setLoading = useSetRecoilState(loadingState);
  const [modeShare, setModeShare] = useState(); 
  const collectioncur = useRecoilValue(collectionsCurState);
  const [boolModif,setBoolModif] = useRecoilState(boolModifState);      
  const setToast = useSetRecoilState(toastState); 
  const [showSaveConfirmModal, setShowSaveConfirmModal] = useState(false);  
  const setCollections = useSetRecoilState(collectionsState);
  const collectionsList = useRecoilValue(collectionsState);
  const [countsByType, setCountsByType] = useState({});
  const [openAddFileEntity, setOpenAddFileEntity] = useState(false);
  // Ids présents avant un import par lots : l'API batch ne renvoie pas les ids créés,
  // on affiche donc au rechargement toute entité absente de cette liste
  const idsBeforeImportRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const allChecked = selectedRows.length === entites.length && entites.length > 0;
  const [isVisible, setIsVisible] = useState(true); // au début = afficher
  const [showStyleForm, setShowStyleForm] = useState(false);
  const [popoverStyle, setPopoverStyle] = useState({ top: 0, left: 0 });
  const [reloadEntite, setReloadEntite] = useRecoilState(reloadEntiteState);
  const addEntiteFile = useRecoilValue(addEntiteFileState); 
  const resetAddEntiteFile = useResetRecoilState(addEntiteFileState);   
  const [bModifStyleForm, setbModifStyleForm] = useState(false);

  const [lastClickedRow, setLastClickedRow] = useState(null);
  
  const addFileRef = useRef(null);   
  

  const typeFR = {
    textMarker: { img: <i className={`fa-solid fa-text ${genStyles.fontSize16}`}></i> },
    marker: { img: <i className={`fa-solid fa-location-dot ${genStyles.fontSize20}`}></i> },
    circle: { img: <i className={`fa-solid fa-circle ${genStyles.fontSize20}`}></i> },
    polyline: { img: <i className={`fa-kit fa-draw-polyline-icon ${genStyles.fontSize20}`}></i> },
    polygon: { img: <i className={`fa-solid fa-vector-polygon ${genStyles.fontSize20}`}></i> },
    rectangle: { img: <i className={`fa-solid fa-vector-square ${genStyles.fontSize20}`}></i> },
  };

  useEffect(() => {
    if(layerEdit){
      let item = entites.find(c => c.id === layerEdit);
      if(item){
        selectAllDataRow(item);
      }
    }
   
    DrawService.onLayerSelect = (layerData) => {
      DrawService.desactiveEdition();
        // Cherche d'abord dans collections
      let item = entites.find(c => c.id === layerData.id);
      DrawService.typeCollectionCur = typeCollection;
      DrawService.infoCollectionCur = collectioncur;    
      if (item) {
          selectAllDataRow(item);       
      }
    };
    initialiseObjectEntite(entites);
  }, [entites]);
  
  useEffect(() => {
    if(!openAddFileEntity){
      const selectedEntities = entites.filter(e => selectedRows.includes(e.id));
      selectedEntities.forEach((item) => {
          DrawService.highlightEntityCollection(item);
      });
    }
  }, [openAddFileEntity]); 

  useEffect(() => {
    if(showStyleForm){
      DrawService.clearHighlight();
    }else{      
      const selectedEntities = entites.filter(e => selectedRows.includes(e.id));
      selectedEntities.forEach((item) => {
          DrawService.highlightEntityCollection(item);
      });
      if(bModifStyleForm){
        let api = api_collection+ user_data.account.port+ '/';
        let userId = user_data.user.id;
        getDataCollectionlist(api, userId, 'reload');
        setbModifStyleForm(false);
      }
    }
  }, [showStyleForm]);  

  useEffect(() => {  
    if(!LocalData && reloadEntite && iddCollectionSelected){          
        if (api_collection && user_data) {
            let api = api_collection+ user_data.account.port+ '/';
            let userId = user_data.user.id;
            getDataCollectionlist(api,userId,'reload'); 
            setReloadEntite(false);          
        }
    }
  }, [reloadEntite]);

  useEffect(() => {  
    if(!LocalData){          
        if (api_collection && user_data) {
            let api = api_collection+ user_data.account.port+ '/';
            let userId = user_data.user.id;
            getDataCollectionlist(api,userId,'load');           
        }
    }
  }, [iddCollectionSelected]);

  const toggleRowCheckbox = (id, event) => {
    setSelectedRows(prev => {
      let updated;

      // Si Shift est pressé et qu'il y a un dernier clic mémorisé
      if (event.shiftKey) {
        
        // Mémoriser le dernier clic
        if(lastClickedRow){
          setLastClickedRow(null);  
        }else{
          setLastClickedRow(id);
        }

        // Trouver les index de la première et dernière ligne
        const startIndex = entites.findIndex(e => e.id === (lastClickedRow ?? id));
        const endIndex = entites.findIndex(e => e.id === id);
        const [from, to] = startIndex < endIndex ? [startIndex, endIndex] : [endIndex, startIndex];
  
        const idsToSelect = entites.slice(from, to + 1).map(e => e.id);
  
        // Mettre à jour selectedRows
        updated = Array.from(new Set([...prev, ...idsToSelect]));
  
        // Appliquer highlight pour toutes les lignes sélectionnées
        idsToSelect.forEach(entityId => {
          const entity = entites.find(e => e.id === entityId);
          if (entity) DrawService.highlightEntityCollection(entity);
        });
      } else {
        // Comportement normal : toggle d'une ligne
        if (prev.includes(id)) {
          updated = prev.filter(x => x !== id);
          DrawService.clearHighlight(id);
        } else {
          updated = [...prev, id];
          const entity = entites.find(e => e.id === id);
          if (entity) DrawService.highlightEntityCollection(entity);
        }
        setLastClickedRow(null);
      }
  
      return updated;
    });
  
  };
  
  const toggleAllCheckboxes = () => {
    if (allChecked) {
      setSelectedRows([]);
      DrawService.clearHighlight();
    } else {
      setSelectedRows(entites.map(r => r.id));
      entites.forEach((item) => {
          DrawService.highlightEntityCollection(item);
      });
    }
  };

  const getDataCollectionlist = (api,userId,type, openStatesParam) => {
    setLoading(true);
    CollectionService.fetchCollectionList(api, userId,iddCollectionSelected).then((response) => {
      setEntites(response);
      if(type == 'load'){
        const isOpen = openStatescoll[iddCollectionSelected] || openShareStates[iddCollectionSelected];
        if (isOpen) {
          setAllOpen(true);
          const newOpenStates = {};
          response.forEach((item) => {
              newOpenStates[item.id] = true;
          });
          setOpenStates(newOpenStates);
        }
      }else{
        if(openStatesParam){
          response.forEach((item) => {
            if (openStatesParam[item.id]) {
              showCollection(item); 
            }
          });
        }else {
          const newOpenStates = { ...openStates }; // on repart de l’existant
          const idsBeforeImport = idsBeforeImportRef.current;
          idsBeforeImportRef.current = null;
          response.forEach((item) => {
              const isImported = idsBeforeImport && !idsBeforeImport.has(String(item.id));
              // 1. Si ajout d’une entité (ou import par lots), on doit la forcer en open
              if (isImported || (addEntiteFile.length > 0 && addEntiteFile.includes(String(item.id)))) {
                  setAllOpen(true);
                  setSelectedRows([]);
                  newOpenStates[item.id] = true;
                  showCollection(item);
              }
              // 2. Sinon : si elle était déjà ouverte, on la rouvre
              else if (openStates[item.id]) {
                  setAllOpen(true);
                  newOpenStates[item.id] = true;
                  showCollection(item);
              }
          });
      
          // Mise à jour finale des openStates
          setOpenStates(newOpenStates);
      
          // Reset si on avait des ajouts
          if (addEntiteFile.length > 0) {
              resetAddEntiteFile();
          }
        }
      }
      setLoading(false);
    });
  };

  const initialiseObjectEntite = (response) => {
    const counts = response.reduce((acc, entite) => {
      const type = entite.type;
      const geometry = entite.geojson?.geometry;
    
      // Initialisation de la clé du type
      if (!acc[type]) {
        acc[type] = {
          count: 0,
          surface: 0,
          longueur: 0,
          surfaceUnit: "m²",
          longueurUnit: "m"
        };
      }
    
      acc[type].count++;
    
      // Calcul selon le type
      if (geometry) {
        const feature = turf.feature(geometry);
                   
        if (type === 'circle') {
          // Pour un cercle → surface en m² selon le rayon dans "options"
          let opts = {};
          if (entite.options) {
              if (typeof entite.options === 'string') {
                  try {
                      opts = JSON.parse(entite.options);
                  } catch (err) {
                      console.warn('Options JSON invalide pour entite:', entite.options);
                      opts = {};
                  }
              } else if (typeof entite.options === 'object') {
                  opts = entite.options;
              }
          }
          if (opts.radius && geometry && geometry.coordinates) {
            const radius = parseFloat(opts.radius);
            const center = geometry.coordinates;
            const circlePolygon = turf.circle(center, radius, { steps: 64, units: 'meters' }); 
            const area = turf.area(circlePolygon); // en m²
            acc[type].surface += area;
          }
        } else if (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
          const area = turf.area(feature);
          acc[type].surface += area;
        } else if (geometry.type === 'LineString' || geometry.type === 'MultiLineString') {
          const length = turf.length(feature, { units: 'meters' });
          acc[type].longueur += length;
        }
      }
    
      return acc;
    }, {});

    // Conversion des unités après le calcul
    Object.keys(counts).forEach((type) => {
      const data = counts[type];
  
      // Longueur : m → km si >= 1000
      if (data.longueur >= 1000) {
        data.longueur = data.longueur / 1000;
        data.longueurUnit = "km";
      }
  
      // Surface : m² → km² si >= 1 000 000
      if (data.surface >= 1_000_000) {
        data.surface = data.surface / 1_000_000;
        data.surfaceUnit = "km²";
      }

      // Arrondir à 2 chiffres après la virgule
      data.longueur = Math.round(data.longueur).toLocaleString("fr-FR").replace(/\u00A0/g, " ");;
      data.surface = Math.round(data.surface).toLocaleString("fr-FR").replace(/\u00A0/g, " ");;
    });
    setCountsByType(counts);
  };

  const toggleAll = () => {
      const newState = !allOpen;
      setAllOpen(newState);
      
      const newOpenStates = {};
      entites.forEach((item) => {
          newOpenStates[item.id] = newState;
          if(newState){
            showCollection(item);
          }else{
            hideCollection(item);
          }
      });
      setOpenStates(newOpenStates);
  };

  const toggleOne = (collection, type) => {
      const id = collection.id;
      setOpenStates((prev) => {
          const isOpen = prev[id];
          const updated = { ...prev, [id]: !prev[id] };
          if(type === 'show'){
            // Action différente selon l'état
            if (isOpen) {
              hideCollection(collection);
            } else {
              showCollection(collection);
            }
          } 
          const hasAnyOpen = Object.values(updated).some((v) => v === true);
          setAllOpen(hasAnyOpen);        
          return updated;
      });
  };
  
  const hideCollection = (collection) => {
    DrawService.removeLayerCollection(collection,'entity');
    if (selectedRows.includes(collection.id)) {
      DrawService.clearHighlight(collection.id);
    }
  }

  const showCollection = (collection) => {
    const geojson = collection.geojson;
    ShowService.addEntitesToMap(geojson,'show');   
    if (selectedRows.includes(collection.id)) {
      DrawService.highlightEntityCollection(collection);
    }
  };

  // Fonction pour vérifier si une date correspond à aujourd'hui
  const isToday = (dateStr) => {
    if (!dateStr) return false;
    const date = new Date(dateStr.replace(" ", "T"));
    const today = new Date();
    return date.getDate() === today.getDate() &&
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear();
  };

  // Fonction pour formater une date avec "aujourd'hui" si nécessaire
  const formatDateWithToday = (dateStr) => {
    if (!dateStr) return "";
    if (isToday(dateStr)) {
      // Extraire l'heure de la date
      const date = new Date(dateStr.replace(" ", "T"));
      const heures = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `aujourd'hui à ${heures}h${minutes}`;
    }
    return ShowService.formatDate(dateStr);
  };

  const getEntityInfo = (row) => {
    if (!row.sogefi_date) return "";        
    const dateCreation = formatDateWithToday(row.sogefi_date);
    const isCreationToday = isToday(row.sogefi_date);
    const prefixCreation = isCreationToday ? "" : "le ";
    let infoText = `Créé par ${row.sogefi_nom_creation || 'Utilisateur inconnu'} ${prefixCreation}${dateCreation}`;
    if (row.sogefi_date_modification) {
      const dateModif = formatDateWithToday(row.sogefi_date_modification);
      const isModifToday = isToday(row.sogefi_date_modification);
      const prefixModif = isModifToday ? "" : "le ";
      infoText += `\n\nDernière modification par ${row.sogefi_nom_modification || 'Utilisateur inconnu'} ${prefixModif}${dateModif}`;
    }
    return infoText;
  };

  const columns = useMemo(() => [
      {
        key: 'group',
        sortable: false,
        width:'20px',
        label: (
          <input 
            className={genStyles.inputtCol}
            type="checkbox" 
            checked={allChecked} // état global
            onChange={() => toggleAllCheckboxes()} 
          />
        ),
        render: (_, row) => (
          <input 
            className={genStyles.inputtCol}
            type="checkbox" 
            checked={selectedRows.includes(row.id)} // état individuel
            onChange={(e) => toggleRowCheckbox(row.id, e)} 
          />
        )
      },
      {
          key: 'affiche',
          sortable: false,
          width:'20px',
          label: (
              <a onClick={toggleAll} >
                  <TooltipForm content={`Afficher/Cacher les entités`}>
                    <i className={`${allOpen ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.maincolorfirsttext}`}></i>
                  </TooltipForm>
              </a>
          ),
          render: (_, row) => (
              <a onClick={(e) => {
                  e.preventDefault(); 
                  toggleOne(row , 'show');
              }}>
                  <TooltipForm content={`Afficher/Cacher l'entité`}>
                    <i  className={`${openStates[row.id] ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.bgcolorfirsttext}`}></i>
                  </TooltipForm>
              </a>
          )
      },
      {
        key: 'titre',
        label: "Nom de l'entité",
        selectable: true,
        // on laisse la largeur se gérer automatiquement pour éviter le scroll horizontal
        render: (_, row) => {
          const textStyle = {
            minHeight: '1em',
            overflow: 'hidden',
            whiteSpace: 'normal',   // permet le retour à la ligne
            wordBreak: 'break-word', // coupe les mots trop longs si besoin
            display: 'block'
          };
      
          // IMPORTANT : passer row à la fonction !
          const tooltipContent = getEntityInfo(row);
      
          if (tooltipContent) {
            return (
              <TooltipForm content={tooltipContent} classNameplus={genStyles.tooltipWrapperFull}>
                <div style={textStyle}>{row.titre}</div>
              </TooltipForm>
            );
          }
      
          return <div style={textStyle}>{row.titre}</div>;
        }
      },      
      { 
          key: 'type', 
          label: "Type",
          align: 'center', 
          selectable: true,
          width:'70px',
          render: (_, row) => {
            const typeInfo = typeFR[row.type];
            const parsedOptions = row?.geojson?.properties?.options;
            const color = parsedOptions?.color || parsedOptions?.icon?.options?.markerColor || '#000';
        
            return (
              <div className="cursor-pointer center-align">
                <span style={{ color }}>
                  {typeInfo?.img}
                </span>
              </div>
            );
          }
      },
      { 
        key: 'nb_fichier', 
        label: 'Fichiers', 
        align: 'center', 
        width: '70px',
        selectable: true,
        sortable: false,
        render: (_, row) => (
          <span>
            {row.geojson?.properties?.nb_fichier ?? 0}
          </span>
        )
      },
      {
          key: 'actions',
          sortable: false,
          label: '',
          subColumns: [
            { key: 'action1', label: '' },
            { key: 'action2', label: '' },
              ...(typeCollection === 'collection' || collectioncur.add
                ? [{ key: 'action3', label: '' }]
                : []),
            ],
          render: (_, row) =>  [
              <td key={`zoom-${row.id}`} style={{width:'30px'}} className='center-align'>
                  <a  onClick={() => zoomEntite(row)} >
                      <TooltipForm content={`Zoomer sur l'entité`}>
                        <i className={`fa-solid fa-magnifying-glass-plus yellow-text text-darken-3 ${genStyles.fontSize16}`}></i>
                      </TooltipForm>
                  </a>
              </td>,
              <td key={`intersec-${row.id}`} style={{width:'30px'}} className='center-align'>
                  <a  onClick={() => getListParcelles(row)} >
                      <TooltipForm content={`Sélectionner les parcelles qui intersectent l'entité`}>
                        <i className={`fa-solid fa-object-intersect bgcolor_first-text text-darken-3 ${genStyles.fontSize16}`}></i>
                      </TooltipForm>
                  </a>
              </td>,
               ...(typeCollection === 'collection' || collectioncur.add
                ? [
                    <td key={`delete-${row.id}`} style={{ width: '30px' }} className='center-align'>
                      <a onClick={() => deleteEntite(row)}>
                        <TooltipForm content={`Supprimer l'entité`}>
                          <i
                            className={`fa-solid fa-trash-can red-text text-darken-2 ${genStyles.fontSize16}`}
                          ></i>
                        </TooltipForm>
                      </a>
                    </td>,
                  ]
                : []),
          ]
      }
  ], [allChecked, allOpen, openStates, toggleAll, toggleOne, typeFR, genStyles]);

  
  const setStyleEntity = (event) => {  
    let selected = selectedRows;
    const rect = event.currentTarget.getBoundingClientRect();
    setPopoverStyle({
        top: rect.bottom + window.scrollY + 5, 
        left: rect.left + window.scrollX,
    });
    const selectedEntities = entites.filter(e => selected.includes(e.id));
    setShowStyleForm(true);
    setObjetCur(selectedEntities);
  };

  const toggleVisibility = () => {    
    let selected = selectedRows;
    if (isVisible) {
      afficheGlobal(selected);  
    } else {
      cacherGlobal(selected);   
    }
    setIsVisible(!isVisible);  
  };

  const zoomGlobal = async() => {
    let selected = selectedRows;
    const selectedEntities = entites.filter(e => selected.includes(e.id));
    const bounds = L.latLngBounds([]);

    for (const collection of selectedEntities) {
      const geojson = collection.geojson;
      const isOpen = openStates[collection.id];
      if (!isOpen) {
        toggleOne(collection, 'zoom');
      }

      const layer = await ShowService.addEntitesToMap(geojson, 'show');
      if (layer[0] && layer[0].getBounds) {
        bounds.extend(layer[0].getBounds());
      } else if (layer[0] && layer[0].getLatLng) {
        bounds.extend(layer[0].getLatLng());
      }
    }
    
    if (bounds.isValid()) {
      DrawService.setZoomEmprise(bounds);
    }
    const selectedEntitiesplus = entites.filter(e => selectedRows.includes(e.id));
    selectedEntitiesplus.forEach((item) => {
        DrawService.highlightEntityCollection(item);
    });
    
  };

  const deleteGlobal = () => {
    let selected = selectedRows;
    const selectedEntities = entites.filter(e => selected.includes(e.id));
    setShowConfirmModalDeleteAll(true);
    setObjetCur(selectedEntities);
  };

  const moveEntitiesToCollection = (targetCollection) => {
    const selectedEntities = entites.filter(e => selectedRows.includes(e.id));
    if (selectedEntities.length === 0) return;

    const api = api_collection + user_data.account.port + '/';
    const userId = user_data.user.id;
    const sourceCollectionId = iddCollectionSelected;

    setLoading(true);

    const payload = selectedEntities.map((entity) => ({
      titre: entity.geojson.properties.titre,
      observation: entity.geojson.properties.observation,
      measure: entity.geojson.properties.measure,
      afficher_centroide: entity.geojson.properties.afficher_centroide,
      tag: entity.geojson.properties.tag,
      type: entity.geojson.properties.type,
      css: (typeof entity.geojson.properties.css === "string") ? entity.geojson.properties.css : JSON.stringify(entity.geojson.properties.css),
      options: JSON.stringify(entity.geojson.properties.options),
      geom: JSON.stringify(entity.geojson.geometry),
    }));

    CollectionService.addEntitesBatch(api, userId, payload, targetCollection.id).then((addResponse) => {
      if (!addResponse || addResponse.success === false) {
        setToast({ message: addResponse?.message || "Erreur lors du déplacement des entités", type: 'error' });
        setLoading(false);
        return;
      }

      const idsToDelete = selectedEntities.map((entity) => entity.idnewbd ?? entity.id);

      CollectionService.deleteMultiEntityFromCollection(api, userId, sourceCollectionId, idsToDelete).then(() => {
        setToast({ message: `Les entités sélectionnées ont été déplacées vers "${targetCollection.nom_affiche}"`, type: 'success' });

        setCollections((prev) =>
          prev.map((col) => {
            if (col.id === sourceCollectionId) {
              return { ...col, nb_entite: Math.max(0, (col.nb_entite || 0) - idsToDelete.length) };
            }
            if (col.id === targetCollection.id) {
              return { ...col, nb_entite: (col.nb_entite || 0) + idsToDelete.length };
            }
            return col;
          })
        );

        selectedEntities.forEach((entity) => {
          DrawService.removeLayerCollection({ id: entity.id }, 'entity');
          DrawService.clearHighlight(entity.id);
        });

        setEntites((prev) => prev.filter((item) => !selectedRows.includes(item.id)));
        setSelectedRows([]);
        setLoading(false);
      });
    });
  };

  const afficheGlobal = (selected) => {
    const selectedEntities = entites.filter(e => selected.includes(e.id));

    for (const collection of selectedEntities) {
      const isOpen = openStates[collection.id];
      if (!isOpen) {
        toggleOne(collection, 'show');
      }
    }
    
  };

  const cacherGlobal = (selected) => {
    const selectedEntities = entites.filter(e => selected.includes(e.id));

    for (const collection of selectedEntities) {
      const isOpen = openStates[collection.id];
      if (isOpen) {
        toggleOne(collection, 'show');
      }
    }
    
  };

  const selectAllDataRow = async(row) => {
    DrawService.typeCollectionCur = typeCollection;
    DrawService.infoCollectionCur = collectioncur;    
    setObjetCur(row);
    const isOpen = openStates[row.id];
    if(!isOpen){
      toggleOne(row, 'edit');
    }
    setTypeEdit(row.type);
    setDataFormulaireMarker(row);
    setLayerEdit(row.id);
    //appelle la fonction pour dessiner le layer sur la carte et active l'edition
    const layeredit = await ShowService.addEntitesToMap(row.geojson,'edit');
    
    ShowService.updateFormEdit(layeredit[0],setForm,setEntites,setBoolModif );
    setActiveNew(false);
    setActiveEdit(true);
  };

  const setDataFormulaireMarker = (row) => {
    let formData = {};
    L.geoJson(row.geojson, {
      onEachFeature: (feature, layer) => {
        const isPoint = typeof layer.getLatLng === 'function';
        const prefix = feature.properties?.options?.icon?.options?.prefix || "";
        const icon   = feature.properties?.options?.icon?.options?.icon || "";
        const iconClassVal = prefix && icon ? `${prefix} ${icon}` : prefix ? `${prefix}` : "";
        formData = {
          nomEntite: row.titre,
          observation: row.observation,
          latitude:  isPoint ? layer.getLatLng().lat : null,
          longitude: isPoint ? layer.getLatLng().lng : null,
          markerShape: feature.properties?.options?.icon?.options?.shape ?? '',
          markerColor: feature.properties?.options?.icon?.options?.markerColor ?? '',
          iconClass : iconClassVal,
          // iconClass: feature.properties?.options?.icon?.options?.prefix+' '+feature.properties?.options?.icon?.options?.icon,
          iconColor: feature.properties?.options?.icon?.options?.iconColor,
          textColor:feature.properties?.css?.color ?? '#252525',
          textSize: (() => {
            const val = parseInt(feature.properties?.css?.["font-size"], 10);
            return Number.isNaN(val) ? '' : val;
          })(),
          lineColor: feature.properties?.options?.color ?? '#92bbf4',
          lineOpacity: feature.properties?.options?.opacity ?? '0.5',
          lineEpaisseur: feature.properties?.options?.weight ?? '4',
          polycontourColor: feature.properties?.options?.color ?? '#92bbf4',
          polycontourOpacity: feature.properties?.options?.opacity ?? '0.5',
          polycontourEpaisseur: feature.properties?.options?.weight ?? '4',
          polyColor: feature.properties?.options?.fillColor ?? feature.properties?.options?.color,
          polyOpacity: feature.properties?.options?.fillOpacity ?? '0.2',
          radius:feature.properties?.options?.radius ?? '0',
          tag : row.tag ?? false,
          measure : row.measure ?? false, 
          afficher_centroide:row.afficher_centroide ?? false, 
        };
      }
    });
    setForm((prev) => ({
      ...prev,
      ...formData
    }));
  };

  const openNewEntity = () => {
    DrawService.desactiveEdition();
    setActiveNew(true);
    setActiveEdit(false);
  };

  const returnToEntityList = () => {
    DrawService.clearAllEvent();
    if(LocalData){
      desactiveEditionandReturnlist();
    }else{
      if(boolModif){
        setShowSaveConfirmModal(true);
      }else{
        desactiveEditionandReturnlist();
      }
    }
  };

  const desactiveEditionandReturnlist = () => {    
    DrawService.desactiveEdition(selectedEntitiesplus);
    
    const selectedEntitiesplus = entites.filter(e => selectedRows.includes(e.id));
    selectedEntitiesplus.forEach((item) => {
        DrawService.highlightEntityCollection(item);
    });
    resetLayerEdit();
    setActiveNew(false);
    setActiveEdit(false);
    setBoolModif(false);     
    
  };

  const returnWithNoSave = () => {
    let api = api_collection+ user_data.account.port+ '/';
    let userId = user_data.user.id;

    const currentEntite = entites.find(item => item.id === layerEdit);
    if(currentEntite){
      const collectiontmp = { id : currentEntite.id }; 
      DrawService.removeLayerCollection(collectiontmp, 'entity');
      setOpenStates(prev => {
        const updated = { ...prev }; // on copie l'ancien état
        const oldId = currentEntite.id;
        const newId = currentEntite.idnewbd;
      
        if (updated.hasOwnProperty(oldId)) {
          updated[newId] = updated[oldId]; // copie la valeur
          delete updated[oldId]; // supprime l'ancien
        }
      
        getDataCollectionlist(api, userId, 'reload', updated);
        return updated;
      });
    }else{
      const collectiontmp = { id : layerEdit }; 
      DrawService.removeLayerCollection(collectiontmp, 'entity');
    }
    
    
    getDataCollectionlist(api, userId, 'reload');
    setShowSaveConfirmModal(false); 
    desactiveEditionandReturnlist();
  };

  const openEntityList = () => {
      let currentEntite = entites.find(item => item.id === layerEdit);
      if(!currentEntite){
        currentEntite = modeleLayer;
      }
      const layercurrent = DrawService.getLayerEdit(layerEdit);

      const idcollection = collectioncur.id;
      const entite = {
        css :  (typeof layercurrent.data.css === "string") ? layercurrent.data.css : JSON.stringify(layercurrent.data.css),
        geom :JSON.stringify(layercurrent.toGeoJSON().geometry),
        id : currentEntite?.idnewbd ?? layercurrent.data.id,
        measure : layercurrent.data?.measure,
        observation : layercurrent.data.observation,
        afficher_centroide : layercurrent.data.afficher_centroide,
        options :  JSON.stringify(layercurrent.data.options),
        tag : layercurrent.data?.tag,
        titre : layercurrent.data.titre,
        type : layercurrent.data.type
      };
     
      setLoading(true);      
      setBoolModif(false);     
      if(!LocalData){
        let api = api_collection+ user_data.account.port+ '/';
        let userId = user_data.user.id;
        CollectionService.updateEntite(api,userId,idcollection,entite).then((response) => {
          if(response.rows){             
            if (currentEntite?.idnewbd) {
              const collectiontmp = { id : currentEntite.id }; 
              DrawService.removeLayerCollection(collectiontmp, 'entity');
              setOpenStates(prev => {
                const updated = { ...prev }; // on copie l'ancien état
                const oldId = currentEntite.id;
                const newId = currentEntite.idnewbd;
              
                if (updated.hasOwnProperty(oldId)) {
                  updated[newId] = updated[oldId]; // copie la valeur
                  delete updated[oldId]; // supprime l'ancien
                }
              
                getDataCollectionlist(api, userId, 'reload', updated);
                return updated;
              });

            }else{
              getDataCollectionlist(api, userId, 'reload');
            }
            setLoading(false);
            setToast({ message: response.message , type: 'success' }); 
          } else {
              setToast({ message: response.message , type: 'error' });
          } 
          desactiveEditionandReturnlist(); 
          setShowSaveConfirmModal(false);
          updateCollectionList();
        });
      }else{        
        setLoading(false);
        desactiveEditionandReturnlist(); 
        setShowSaveConfirmModal(false);
        updateCollectionList();
      }

  };

  const updateCollectionList = () => {
    let api = api_collection+ user_data.account.port+ '/';
    let userId = user_data.user.id;
    CollectionService.fetchCollection(api, userId).then((response) => {            
      const counts = {};
      const formatted = response.map((item) => {
        const name = item.nom_collection;
    
        if (counts[name] === undefined) {
            counts[name] = 0;
        } else {
            counts[name]++;
        }
    
        const suffix = counts[name] === 0 ? '' : ` (${counts[name]})`;
    
        return {
            ...item,
            nom_affiche: `${name}${suffix}`, 
        };
      });
      setCollections(formatted);     

    });
  };
  
  const deleteEntityList = () => {
    let currentEntite = entites.find(item => item.id === layerEdit);
    if(!currentEntite){
      currentEntite = modeleLayer;
    }
    deleteEntite(currentEntite);
  };

  const zoomEntite = (collection) => {
    const geojson = collection.geojson;
    const isOpen = openStates[collection.id];
    if(!isOpen){
      toggleOne(collection, 'edit');
    }
    ShowService.addEntitesToMap(geojson,'zoom');
     if (selectedRows.includes(collection.id)) {
      DrawService.highlightEntityCollection(collection);
    }
  };

  const getListParcelles = (collection) => {
    let entiteparc = collection.geojson;
    if(entiteparc.properties.type == "circle"){
      var circlePolygon = turf.circle(entiteparc.geometry.coordinates, entiteparc.properties.options.radius, {
          steps: 12,
          units: 'meters'
      });
      entiteparc = circlePolygon;
    }

    const dataparc = {"geojson": entiteparc.geometry};
    
    if (turf.area(entiteparc) < 40000) {
      CollectionService.getParcelleFromGeojson(dataparc,api_pci).then((response) => {
          if (!response || !Array.isArray(response.features)) {
            setToast({ message: "Emprise trop étendue, veuillez réduire la surface de la sélection" , type: 'error' }); 
          } else {
            if(response?.features.length === 0){
              setToast({ message: "Aucune parcelle n'intersecte votre entité ou vous n’êtes pas dans votre territoire." , type: 'error' }); 
            }else{
              if (onParcellesFetched) {
                onParcellesFetched(response); 
              }             
            }        
          }     
      });
    }else{
      setToast({ message: "Emprise trop étendue, veuillez réduire la surface de la sélection" , type: 'error' }); 
    }
  };

  const deleteEntite = (item) => {
    setShowConfirmModal(true);
    setObjetCur(item);
  };

  const openCollectionList = () => {
    DrawService.clearHighlight();
    DrawService.clearAllEvent();
    DrawService.desactiveEdition();
    const defaultCollection = LocalData ? 'Défault' : null;
    setSelected(defaultCollection);
    let result = Object.values(openStates).some(v => v !== false);
    setOpenStatesColl(prev => ({
      ...prev,
      [collectioncur.id]: result,
    }));
    DrawService.redrawEntityCollection(null);
  };

  const exportXlsEntite = () => {
    ExcelService.exportEntite(entites,collectionName);
  };

  const exportCartoEntite = () => {
    let api = api_collection+ user_data.account.port+ '/';
    let userId = user_data.user.id;
    if(typeCollection == 'shared'){
      userId = collectioncur.sogefi_operateur_creation;
    }
    setLoading(true);
    CollectionService.exportSigEntite(api, userId,iddCollectionSelected).then((blob) => {
      if(blob.errors){
        setToast({ message: blob.errors , type: 'error' });
        setLoading(false);
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // Nom du fichier
      const safeName = collectionName.replace(/\s+/g, "_").replace(/[\[\]\:*?/\\]/g, ""); 
      a.download = collectionName+'.gpkg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    });
  };

  const sharedCollection = () => {
    setLoading(true);
    setModeShare('edit');
    setShowSharedModal(true);
  };

  const showSharedCollection = () => {
    setLoading(true);
    setModeShare('show');
    setShowSharedModal(true);
  };

  const openPopAddEntityFile = () => {  
    DrawService.clearHighlight();
    setOpenAddFileEntity(true);
  };

  const closeEntityFile = () => {
    addFileRef.current?.closeLayerEntity();
  };

  const exportKmlEntite = () => {
    if (!entites || entites.length === 0) {
      setToast({ message: "Pas de données à exporter", type: "success" });
      return;
    }
  
    // Construire une FeatureCollection
    const featureCollection = {
      type: "FeatureCollection",
      features: entites.map(e => e.geojson)
    };
  
    // Convertir GeoJSON → KML (renvoie directement une string)
    const kmlString = toKML(featureCollection);
  
    const fileName = normalizeFileName(collectionName);
    downloadKML(kmlString, fileName);
  };

  const downloadKML = (kmlString, filename = "export.kml") => {
    const blob = new Blob([kmlString], { type: "application/vnd.google-earth.kml+xml" });
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const normalizeFileName = (name) => {
    if (!name) return "export.kml";
  
    // 1️⃣ enlever les caractères interdits
    let normalized = name.replace(/[\/\\:*?"<>|]/g, "");
  
    // 2️⃣ remplacer les espaces ou caractères spéciaux par des underscores
    normalized = normalized.replace(/\s+/g, "_");
  
    // 3️⃣ limiter la longueur si nécessaire (ex: 100 caractères max)
    if (normalized.length > 100) {
      normalized = normalized.substring(0, 100);
    }
  
    // 4️⃣ ajouter l’extension KML
    return normalized + ".kml";
  };
  
  // Condition commune :
  const allowAdd = typeCollection === "collection" || collectioncur?.add;

  const actionsRightEntite = [
    ...(allowAdd && initGeocoder
      ? [{
          icon: <i className={`fa-regular fa-file-import ${genStyles.fontSize18}`} />,
          label: "Importer un fichier",
          onClick: openPopAddEntityFile,
          disabled: false,
        }]
      : []),  
      {
        label: "Exporter les entités",
        icon: <i className="fa-regular fa-file-export" />,
        submenu: [        
          ...(!LocalData
            ? [{
                label: "GPKG",
                onClick: exportCartoEntite,
                disabled: false,
              }]
            : []),
            {
              label: "KML",
              onClick: exportKmlEntite,
              disabled: false,
            },
            {
              label: "XLS",
              onClick: exportXlsEntite,
              disabled: false,
            },
        ]
      },
    ...(!LocalData && typeCollection === 'collection'
      ? [{
          icon: <i className={`fa-solid fa-share-nodes ${genStyles.fontSize18}`} />,
          label: "Partager la collection",
          onClick: sharedCollection,
          disabled: false,
        }]
      : []),
    ...(!LocalData && typeCollection === 'shared'
      ? [{
          icon: <i className={`fa-kit fa-solid-share-nodes-circle-user ${genStyles.fontSize18}`} />,
          label: "Voir les utilisateurs ayant accès à la collection",
          onClick: showSharedCollection,
          disabled: false,
        }]
      : [])
  ];
  
  const actionsbulk = [
    {
      icon: isVisible 
      ? <i className={`fa-solid fa-eye ${genStyles.fontSize18}`} />
      : <i className={`fa-solid fa-eye-slash ${genStyles.fontSize18}`} />,
      label: isVisible ? "Afficher les entités sélectionnées" : "Cacher les entités sélectionnées",
      onClick: () => toggleVisibility(),
      disabled: false,
    },
    {
      icon: <i className={`fa-solid fa-magnifying-glass-plus ${genStyles.fontSize18} yellow-text text-darken-3`} />,
      label: "Zoomer sur les entités sélectionnées",
      onClick:  () => zoomGlobal(),
      disabled: false,
    }
  ];

  const targetCollectionsForMove = collectionsList.filter((col) => col.id !== iddCollectionSelected);

  if (typeCollection === "collection") {
    // Dans une collection : afficher delete + edit
    actionsbulk.push(
      {
        icon: <i className={`fa-solid fa-palette ${genStyles.fontSize18} blue-text text-darken-3`} />,
        label: "Éditer le style des entités sélectionnées",
        onClick: (e) => setStyleEntity(e),
        disabled: false,
      }
    );

    if (!LocalData && targetCollectionsForMove.length > 0) {
      actionsbulk.push({
        icon: <i className={`fa-solid fa-right-left ${genStyles.fontSize18} blue-text text-darken-3`} />,
        label: "Déplacer vers",
        submenu: targetCollectionsForMove.map((col) => ({
          label: col.nom_affiche,
          onClick: () => moveEntitiesToCollection(col),
        })),
      });
    }

    actionsbulk.push(
      {
        icon: <i className={`fa-solid fa-trash-can ${genStyles.fontSize18} red-text text-darken-2`} />,
        label: "Supprimer les entités sélectionnées",
        onClick: () => deleteGlobal(),
        disabled: false,
      }
    );
  }

  else if (typeCollection === "shared") {
    // Si c'est partagé, vérifier les permissions
    if (collectioncur?.edit === true) {
      actionsbulk.push({
        icon: <i className={`fa-solid fa-palette ${genStyles.fontSize18}`} />,
        label: "Éditer le style des entités",
        onClick: (e) => setStyleEntity(e),
        disabled: false,
      });
    }
  
    if (collectioncur?.delete === true) {
      actionsbulk.push({
        icon: <i className={`fa-solid fa-trash-can ${genStyles.fontSize18}`} />,
        label: "Supprimer les entités",
        onClick: () => deleteGlobal(),
        disabled: false,
      });
    }
  }
  

  const showReturnToEntities =
    openAddFileEntity || activeNew || activeEdit;

  const handleReturnToEntities = () => {
    if (openAddFileEntity) {
      return closeEntityFile();
    }
    if (activeNew || activeEdit) {
      return returnToEntityList();
    }
  };

  return (
    <div className="row mb0">
        <div className="col s12">
          <div className={genStyles.collectionHeaderBar}>
            <span className={genStyles.collectionHeaderText}>
              <span className={genStyles.collectionHeaderLabel}>Collection</span>
              <span className={genStyles.collectionHeaderTitle}>
                {(typeCollection == 'collection') &&(
                  <TooltipForm content={`Vous êtes le propriétaire de la collection`}>
                    <i className={`fa-solid fa-crown yellow-text text-darken-3`}></i>
                  </TooltipForm>
                )}
                {(typeCollection == 'shared') &&(
                  <TooltipForm content={`Cette collection est partagée avec vous`}>
                    <i className={`fa-solid fa-share-nodes ${genStyles.bgcolorfirsttext}`}></i>
                  </TooltipForm>
                )}
                {collectionName}
              </span>
            </span>

            {showReturnToEntities && (
              <button
                onClick={handleReturnToEntities}
                className={genStyles.btnBack}
              >
                <i className={`fa fa-arrow-left`}></i>
                Retour
              </button>
            )}
            {!openAddFileEntity && !LocalData && !activeEdit && !activeNew && (
                <button
                    onClick={openCollectionList}
                    className={genStyles.btnBack}
                  >
                    <i className={`fa fa-arrow-left`}></i>
                    Retour
                </button>
            )}
          </div>

          <div>
            {/* Statistiques des entités - pleine largeur, sous le header */}
            {!activeNew && !activeEdit && !openAddFileEntity && (
              <div className={genStyles.entityStatsContainer}>
                <TooltipForm content={`${countsByType?.marker?.count || 0} marqueur(s)`}>
                  <span className={genStyles.contenuInfo}>
                    <span className={genStyles.statValue}>
                      <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                      {countsByType?.marker?.count || 0}
                    </span>
                    <span className={genStyles.statLabel}>Marqueurs</span>
                  </span>
                </TooltipForm>
                <TooltipForm content={`${countsByType?.textMarker?.count || 0} texte(s) libre(s)`}>
                  <span className={genStyles.contenuInfo}>
                    <span className={genStyles.statValue}>
                      <i className="fa-solid fa-text" aria-hidden="true"></i>
                      {countsByType?.textMarker?.count || 0}
                    </span>
                    <span className={genStyles.statLabel}>Textes</span>
                  </span>
                </TooltipForm>
                <TooltipForm content={`${countsByType?.circle?.count || 0} cercle(s) — ${countsByType?.circle?.surface || '0'} ${countsByType?.circle?.surfaceUnit || 'm²'}`}>
                  <span className={genStyles.contenuInfo}>
                    <span className={genStyles.statValue}>
                      <i className="fa-solid fa-circle" aria-hidden="true"></i>
                      {countsByType?.circle?.count || 0}
                    </span>
                    <span className={genStyles.statLabel}>Cercles</span>
                  </span>
                </TooltipForm>
                <TooltipForm content={`${countsByType?.polyline?.count || 0} ligne(s) — ${countsByType?.polyline?.longueur || '0'} ${countsByType?.polyline?.longueurUnit || 'm'}`}>
                  <span className={genStyles.contenuInfo}>
                    <span className={genStyles.statValue}>
                      <i className="fa-kit fa-draw-polyline-icon" aria-hidden="true"></i>
                      {countsByType?.polyline?.count || 0}
                    </span>
                    <span className={genStyles.statLabel}>Lignes</span>
                  </span>
                </TooltipForm>
                <TooltipForm content={`${countsByType?.rectangle?.count || 0} rectangle(s) — ${countsByType?.rectangle?.surface || '0'} ${countsByType?.rectangle?.surfaceUnit || 'm²'}`}>
                  <span className={genStyles.contenuInfo}>
                    <span className={genStyles.statValue}>
                      <i className="fa-solid fa-vector-square" aria-hidden="true"></i>
                      {countsByType?.rectangle?.count || 0}
                    </span>
                    <span className={genStyles.statLabel}>Rectangles</span>
                  </span>
                </TooltipForm>
                <TooltipForm content={`${countsByType?.polygon?.count || 0} polygone(s) — ${countsByType?.polygon?.surface || '0'} ${countsByType?.polygon?.surfaceUnit || 'm²'}`}>
                  <span className={genStyles.contenuInfo}>
                    <span className={genStyles.statValue}>
                      <i className="fa-solid fa-vector-polygon" aria-hidden="true"></i>
                      {countsByType?.polygon?.count || 0}
                    </span>
                    <span className={genStyles.statLabel}>Polygones</span>
                  </span>
                </TooltipForm>
              </div>
            )}

          </div>
        </div>

        {!openAddFileEntity && !activeNew && !activeEdit && (
          <>
            <div className="col s12 center-align">
                <ResultForm 
                  data={entites} 
                  columns={columns} 
                  onSelectRow={selectAllDataRow} 
                  pageSize={10} 
                  tableHeight="auto" 
                  textpaginate="entités" 
                  texteSearch="Rechercher"
                  sortConfig={sortConfigEntity}
                  setSortConfig={setSortConfigEntity}
                  searchQuery={searchQueryEntity}
                  setSearchQuery={setSearchQueryEntity}
                  currentPage={currentPageEntity}
                  setCurrentPage={setCurrentPageEntity}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  bulkActions={actionsbulk}
                  actionsRight={actionsRightEntite}  
                  actionsButtonRight={
                    <>
                      {(typeCollection == 'collection' || collectioncur.add) &&(
                        <TooltipForm content={`Ajouter une entité`}>
                          <button
                            type="button"
                            className={`${menuStyles.butMenu} ${menuStyles.butMenuPrimary}`}
                            onClick={openNewEntity}
                          >
                            <i className={`fa-sharp fa-regular fa-square-plus`}></i>
                          </button>
                        </TooltipForm>
                      )}
                    </>
                  }                
                />
            </div>
          </>      
        )}

        {openAddFileEntity && (
          <div className={`col s12 ${genStyles.genbackground}`}>
            <Suspense fallback={<div>Chargement de l’éditeur...</div>}>
              <AddEntityFileForm ref={addFileRef} onClose={() => setOpenAddFileEntity(false)} setOpenStates={setOpenStates} setEntiteslist={setEntites} iddCollectionSelected={iddCollectionSelected} initGeocoder={initGeocoder} fileTypesLinks={fileTypesLinks} mymap={mymap} featureGroup={featureGroup} onBeforeBatchImport={() => { idsBeforeImportRef.current = new Set(entites.map(e => String(e.id))); }}/>
            </Suspense>   
          </div>
        )}

        {activeNew && (
          <div className="col s12 center-align">
              <EntityNewForm setEntiteslist={setEntites} setOpenStates={setOpenStates} modeleCollection={modeleCollection} />
          </div>
        )}
        
        {activeEdit && typeEdit === 'marker' && (
          <div className="col s12">
          <MarkerForm  setEntiteslist={setEntites} openEntityList={openEntityList} deleteEntityList={deleteEntityList} objectCur={objetCur} returnToEntityList={returnToEntityList} collectionName={collectionName} />
          </div>
        )}
        
        {activeEdit && typeEdit === 'textMarker' && (
          <div className="col s12">
          <MarkerTextForm  setEntiteslist={setEntites} openEntityList={openEntityList} deleteEntityList={deleteEntityList} objectCur={objetCur} returnToEntityList={returnToEntityList} collectionName={collectionName} />
          </div>
        )}

        {activeEdit && typeEdit === 'polyline' && (
          <div className="col s12">
          <PolylineForm  setEntiteslist={setEntites} openEntityList={openEntityList} deleteEntityList={deleteEntityList} objectCur={objetCur} returnToEntityList={returnToEntityList} collectionName={collectionName} />
          </div>
        )}

        {activeEdit && (typeEdit === 'rectangle' || typeEdit === 'polygon') && (
          <div className="col s12">
            <PolygonForm setEntiteslist={setEntites} openEntityList={openEntityList} deleteEntityList={deleteEntityList} objectCur={objetCur} returnToEntityList={returnToEntityList} collectionName={collectionName} />
          </div>
        )}

        {activeEdit && typeEdit === 'circle' && (
          <div className="col s12">
            <CircleForm setEntiteslist={setEntites} openEntityList={openEntityList} deleteEntityList={deleteEntityList} objectCur={objetCur} returnToEntityList={returnToEntityList} collectionName={collectionName} />
          </div>
        )}

        {showConfirmModal && (
            <FullScreenModal>
                <DeleteCollectionForm onClose={() => setShowConfirmModal(false)} objectCur={objetCur} type='entity' setEntites={setEntites}/>
            </FullScreenModal>
        )}

        {showConfirmModalDeleteAll && (
            <FullScreenModal>
                <DeleteCollectionForm onClose={() => setShowConfirmModalDeleteAll(false)} objectCur={objetCur} type='deleteallentity' setEntites={setEntites}/>
            </FullScreenModal>
        )}

        {showSharedModal && (
            <FullScreenModal>
                <SharedCollectionForm onClose={() => setShowSharedModal(false)} collectionName={collectionName} mode={modeShare} />
            </FullScreenModal>
        )}

        {showSaveConfirmModal && (
            <FullScreenModal>
              <ConfirmSaveForm onClose={returnWithNoSave} onValidate={openEntityList} />
            </FullScreenModal>        
        )}

        {showStyleForm && (
            <div className={genStyles.modalsetstyle}>
                <SetStyleForm onClose={() => setShowStyleForm(false) } setbModifStyleForm={setbModifStyleForm} objectCur={objetCur} setEntites={setEntites} popoverStyle={popoverStyle} saveaction='oui' />               
            </div>
        )}
    </div>
  );
}
